import ToastHighLighter from '@/lib/ToastHighLighter';

export const ButtonStandard = () => {
  const language = 'html';
  const codeString = `
  // Standard buttons primary and secondary
  <a class="btn btn-primary me-1" href="#">
    A-Tag Button
  </a>
  <button class="btn btn-secondary mx-1" href="#">
    A-Tag Button
  </button>
  <button class="btn btn-light" type="reset">
    Reset Button
 </button>
  `;

  return (
    <>
      <ToastHighLighter
        name={'button'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};

export const ButtonGroupCode = () => {
  const language = 'html'; //'htmlbars';
  const codeString = `
  // Button group - primary and secondary
  <div class="btn-group" role="group" aria-label="Basic example">
    <button type="button" class="btn btn-secondary">
      Left
    </button>
    <button type="button" class="btn btn-secondary">
      Middle
    </button>
    <button type="button" class="btn btn-secondary">
      Right
    </button>
  </div>
  `;

  return (
    <>
      <ToastHighLighter
        name={'buttongroup'}
        codeString={codeString}
        language={language}
        show={false}
      />
    </>
  );
};

export const SmallButtons = () => {
  const language = 'html'; //'htmlbars';
  const codeString = `
  // Small buttons - primary and secondary
  <a class="btn btn-primary btn-sm" href="#">
    A-Tag Button Small
  </a>
  <a class="btn btn-secondary btn-sm" href="#">
    A-Tag Button Small
  </a>
  `;

  return (
    <>
      <ToastHighLighter
        name={'smallbuttons'}
        codeString={codeString}
        language={language}
        show={false}
      />
    </>
  );
};

export const LargeButtons = () => {
  const language = 'html'; //'htmlbars';
  const codeString = `
  // Large buttons - primary and secondary
  <a class="btn btn-primary btn-lg" href="#">
    A-Tag Button Large
  </a>
  <a class="btn btn-secondary btn-lg" href="#">
    A-Tag Button Large
  </a>
  `;

  return (
    <>
      <ToastHighLighter
        name={'largebuttons'}
        codeString={codeString}
        language={language}
        show={false}
      />
    </>
  );
};

export const ButtonsOutlined = () => {
  const language = 'html'; //'htmlbars';
  const codeString = `
  // Buttons Outlined - all colors
  <button type="button" class="btn btn-outline-primary">
    Primary
  </button>
  <button type="button" class="btn btn-outline-secondary">
    Secondary
  </button>
  <button type="button" class="btn btn-outline-success">
    Success
  </button>
  <button type="button" class="btn btn-outline-danger">
    Danger
  </button>
  <button type="button" class="btn btn-outline-warning">
    Warning
  </button>
  <button type="button" class="btn btn-outline-info">
    Info
  </button>
  <button type="button" class="btn btn-outline-light">
    Light
  </button>
  <button type="button" class="btn btn-outline-dark">
    Dark
  </button>  
  `;

  return (
    <>
      <ToastHighLighter
        name={'buttonoutlined'}
        codeString={codeString}
        language={language}
        show={false}
      />
    </>
  );
};

export const ButtonCollection = () => {
  const language = 'html'; //'htmlbars';
  const codeString = `
  // Button Collection - all colors
  <button type="button" class="btn btn-outline-primary">
    Primary
  </button>
  <button type="button" class="btn btn-outline-secondary">
    Secondary
  </button>
  <button type="button" class="btn btn-outline-success">
    Success
  </button>
  <button type="button" class="btn btn-outline-danger">
    Danger
  </button>
  <button type="button" class="btn btn-outline-warning">
    Warning
  </button>
  <button type="button" class="btn btn-outline-info">
    Info
  </button>
  <button type="button" class="btn btn-outline-light">
    Light
  </button>
  <button type="button" class="btn btn-outline-dark">
    Dark
  </button>  
  `;

  return (
    <>
      <ToastHighLighter
        name={'buttoncollection'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};

export const CloseButtonCode = () => {
  const language = 'html'; //'htmlbars';
  const codeString = `
  // Close button

  <button type="button" className="btn-close" aria-label="Close"></button>
  `;

  return (
    <>
      <ToastHighLighter
        name={'closeButtonCode'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};

export const LinkButtonCode = () => {
  const language = 'html'; //'htmlbars';
  const codeString = `
  // Link button

  <a className="btn btn-primary" href="#" role="button">
    Link
  </a>
  `;

  return (
    <>
      <ToastHighLighter
        name={'closeButtonCode'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
